import { graphql } from '@api/gql';

export const countIntegrationResourcesDocument = graphql(/* GraphQL */ `
  query CountIntegrationResources($id: String!, $filter: IntegrationResourcesFilterInput) {
    integrationResources(id: $id, filter: $filter) {
      totalCount
    }
  }
`);

export const standingAccessReportResourceFragmentDocument = graphql(/* GraphQL */ `
  fragment standingAccessReportResourceFragment on StandingAccessReportResource {
    id
    name
    type {
      type
      typeDisplayName
      icons {
        png
        svg
      }
    }
  }
`);

export const standingAccessReportPermissionFragmentDocument = graphql(/* GraphQL */ `
  fragment standingAccessReportPermissionFragment on StandingAccessReportPermission {
    id
    name
  }
`);

export const standingAccessReportEntitlementFragmentDocument = graphql(/* GraphQL */ `
  fragment standingAccessReportEntitlementFragment on StandingAccessReportEntitlement {
    id
    resource {
      ...standingAccessReportResourceFragment
    }
    permission {
      ...standingAccessReportPermissionFragment
    }
    identitiesCount
    revokedCount
    inAccessFlowCount
    riskScore
    lastUsedAt
    tier
  }
`);

export const getStandingAccessReportEntitlementsDocument = graphql(/* GraphQL */ `
  query GetStandingAccessReportEntitlements(
    $reportId: String!
    $filter: StandingAccessReportEntitlementFilterInput
    $pagination: NaivePaginationInput
  ) {
    standingAccessReportEntitlements(id: $reportId, filter: $filter, pagination: $pagination) {
      totalCount
      edges {
        node {
          ...standingAccessReportEntitlementFragment
        }
        cursor
      }
    }
  }
`);

export const standingAccessReportUsageFragmentDocument = graphql(/* GraphQL */ `
  fragment standingAccessReportUsageFragment on StandingAccessReportUsage {
    id
    identity {
      id
      name
      email
    }
    identityLinks {
      id
      name
      type
      revoked
    }
    lastUsedAt
    riskScore
    tier
    revoked
    inAccessFlow
  }
`);

export const getStandingAccessReportUsagesDocument = graphql(/* GraphQL */ `
  query GetStandingAccessReportUsages(
    $reportId: String!
    $groupCursor: String!
    $filter: StandingAccessReportEntitlementFilterInput
    $pagination: NaivePaginationInput
  ) {
    standingAccessReportEntitlementsUsages(
      id: $reportId
      groupCursor: $groupCursor
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      edges {
        node {
          ...standingAccessReportUsageFragment
        }
      }
    }
  }
`);

export const getStandingAccessReportFilterOptionsResourcesDocument = graphql(/* GraphQL */ `
  query GetStandingAccessReportFilterOptionsResources(
    $reportId: String!
    $search: String
    $pagination: NaivePaginationInput
  ) {
    standingAccessReportFilterOptions(id: $reportId) {
      resources(search: $search, pagination: $pagination) {
        hasMore
        data {
          ...standingAccessReportResourceFragment
        }
      }
    }
  }
`);

export const getStandingAccessReportFilterOptionsPermissionsDocument = graphql(/* GraphQL */ `
  query GetStandingAccessReportFilterOptionsPermissions(
    $reportId: String!
    $search: String
    $pagination: NaivePaginationInput
  ) {
    standingAccessReportFilterOptions(id: $reportId) {
      permissions(search: $search, pagination: $pagination) {
        hasMore
        data {
          ...standingAccessReportPermissionFragment
        }
      }
    }
  }
`);

export const getStandingAccessReportFilterOptionsRiskScoresDocument = graphql(/* GraphQL */ `
  query GetStandingAccessReportFilterOptionsRiskScores($reportId: String!) {
    standingAccessReportFilterOptions(id: $reportId) {
      riskScores
    }
  }
`);

export const getStandingAccessReportFilterOptionsLinkedElementsDocument = graphql(/* GraphQL */ `
  query GetStandingAccessReportFilterOptionsLinkedElements(
    $reportId: String!
    $search: String
    $filter: StandingAccessReportEntitlementFilterInput
    $pagination: NaivePaginationInput
  ) {
    standingAccessReportFilterOptions(id: $reportId) {
      linkedElements(search: $search, filter: $filter, pagination: $pagination) {
        hasMore
        data {
          ...standingAccessReportEntitlementLinkedElementFragment
        }
      }
    }
  }
`);

export const standingAccessReportTierCountsFragmentDocument = graphql(/* GraphQL */ `
  fragment standingAccessReportTierCountsFragment on StandingAccessReportTierCounts {
    entitlementsCount
    usagesCount
    revokedCount
    inAccessFlowCount
  }
`);

export const getStandingAccessReportTierCountsDocument = graphql(/* GraphQL */ `
  query GetStandingAccessReportTierCounts($reportId: String!) {
    criticalTier: standingAccessReportTierCounts(id: $reportId, tier: "Critical") {
      ...standingAccessReportTierCountsFragment
    }
    highTier: standingAccessReportTierCounts(id: $reportId, tier: "High") {
      ...standingAccessReportTierCountsFragment
    }
    mediumTier: standingAccessReportTierCounts(id: $reportId, tier: "Medium") {
      ...standingAccessReportTierCountsFragment
    }
    lowTier: standingAccessReportTierCounts(id: $reportId, tier: "Low") {
      ...standingAccessReportTierCountsFragment
    }
  }
`);

export const standingAccessReportEntitlementLinkedElementFragmentDocument = graphql(/* GraphQL */ `
  fragment standingAccessReportEntitlementLinkedElementFragment on StandingAccessReportEntitlementLinkedElement {
    id
    name
    type
  }
`);

export const standingAccessReportEntitlementLinkFragmentDocument = graphql(/* GraphQL */ `
  fragment standingAccessReportEntitlementLinkFragment on StandingAccessReportEntitlementLink {
    id
    tiers
    resource {
      ...standingAccessReportResourceFragment
    }
    permission {
      ...standingAccessReportPermissionFragment
    }
    riskScore
    lastUsedAt
    linkedElement {
      ...standingAccessReportEntitlementLinkedElementFragment
    }
  }
`);

export const getStandingAccessReportEntitlementLinksDocument = graphql(/* GraphQL */ `
  query GetStandingAccessReportEntitlementLinks(
    $reportId: String!
    $filter: StandingAccessReportEntitlementFilterInput
    $pagination: NaivePaginationInput
  ) {
    standingAccessReportEntitlementLinks(id: $reportId, filter: $filter, pagination: $pagination) {
      totalCount
      edges {
        node {
          ...standingAccessReportEntitlementLinkFragment
        }
      }
    }
  }
`);

export const getStandingAccessReportEntitlementLinksExportDataDocument = graphql(/* GraphQL */ `
  query GetStandingAccessReportEntitlementLinksExportData(
    $reportId: String!
    $filter: StandingAccessReportEntitlementFilterInput
    $selection: StandingAccessReportEntitlementExportSelectionInput
  ) {
    standingAccessReportEntitlementLinksExportData(id: $reportId, filter: $filter, selection: $selection)
  }
`);
